/* Generated by scripts/gen_diagram_palette_ts.py. Do not edit by hand. */
export interface DiagramSwatch {
  fill: string;
  stroke: string;
  text: string;
  darkFill: string;
  darkStroke: string;
  dash: string;
  meaning: string;
}

export const diagramPage = { fill: '#f8fafc', text: '#0f172a' };

export const diagramPalette: Record<string, DiagramSwatch> = {
  victim: { fill: '#fee2e2', stroke: '#dc2626', text: '#991b1b', darkFill: '#450a0a', darkStroke: '#f87171', dash: '', meaning: 'The complainant, or the wallet that lost the funds.' },
  subject: { fill: '#fef08a', stroke: '#ca8a04', text: '#854d0e', darkFill: '#422006', darkStroke: '#facc15', dash: '', meaning: 'The wallet under investigation.' },
  cex: { fill: '#ffedd5', stroke: '#ea580c', text: '#9a3412', darkFill: '#431407', darkStroke: '#fb923c', dash: '', meaning: 'An exchange or other service. This orange is the exchange, not the email blue.' },
  cex_deposit_verified: { fill: '#ecfdf5', stroke: '#059669', text: '#065f46', darkFill: '#022c22', darkStroke: '#34d399', dash: '', meaning: 'An exchange deposit the entity database has confirmed.' },
  mule: { fill: '#f3e8ff', stroke: '#9333ea', text: '#6b21a8', darkFill: '#2e1065', darkStroke: '#c084fc', dash: '', meaning: 'A relay or mule wallet.' },
  bridge: { fill: '#e0f2fe', stroke: '#0284c7', text: '#075985', darkFill: '#082f49', darkStroke: '#38bdf8', dash: '', meaning: 'A bridge between chains.' },
  btc: { fill: '#fef9c3', stroke: '#eab308', text: '#713f12', darkFill: '#422006', darkStroke: '#facc15', dash: '', meaning: 'A Bitcoin or other UTXO-chain address.' },
  mixer: { fill: '#18181b', stroke: '#a855f7', text: '#f4f4f5', darkFill: '#09090b', darkStroke: '#c084fc', dash: '', meaning: 'A mixer or privacy pool.' },
  spam: { fill: '#f1f5f9', stroke: '#94a3b8', text: '#475569', darkFill: '#1e293b', darkStroke: '#64748b', dash: '4 4', meaning: 'Poisoning or spam.' },
  court: { fill: '#faf5ff', stroke: '#a78bfa', text: '#5b21b6', darkFill: '#1e1228', darkStroke: '#c4b5fd', dash: '', meaning: 'A court or legal hold.' },
  card: { fill: '#fdf2f8', stroke: '#db2777', text: '#9d174d', darkFill: '#500724', darkStroke: '#f472b6', dash: '', meaning: 'A card off-ramp.' },
  identifier_email: { fill: '#eff6ff', stroke: '#2563eb', text: '#1e3a8a', darkFill: '#172a42', darkStroke: '#60a5fa', dash: '4 4', meaning: 'An email identifier. This blue is not an exchange.' },
  identifier_phone: { fill: '#ecfdf5', stroke: '#047857', text: '#064e3b', darkFill: '#0d3328', darkStroke: '#6ee7b7', dash: '4 4', meaning: 'A phone identifier.' },
  identifier_upi: { fill: '#ede9fe', stroke: '#7c3aed', text: '#4c1d95', darkFill: '#2d1f3d', darkStroke: '#a78bfa', dash: '', meaning: 'A UPI identifier.' },
};

export function diagramFace(key: string, dark: boolean): { background: string; border: string; dash: string } {
  const row = diagramPalette[key];
  return {
    background: dark ? row.darkFill : row.fill,
    border: dark ? row.darkStroke : row.stroke,
    dash: row.dash,
  };
}
